var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.239,
    height: 31.24,
    viewBox: "0 0 31.239 31.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4449",
    "data-name": "Grupo 4449",
    transform: "translate(12119.646 1618.926)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2774",
    "data-name": "Grupo 2774",
    transform: "translate(-12119.646 -1618.926)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4450",
    "data-name": "Grupo 4450",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1859",
    "data-name": "Trazado 1859",
    d: "M72.354,73.489c-1.805,0-2.968-1.438-2.968-3.663s1.159-3.662,2.954-3.662a2.5,2.5,0,0,1,2.623,1.975h1.1a3.321,3.321,0,0,0-1.154-2.092,3.93,3.93,0,0,0-2.583-.891,4.179,4.179,0,0,0-1.677.331,3.63,3.63,0,0,0-1.287.94,4.263,4.263,0,0,0-.827,1.47,6.074,6.074,0,0,0-.3,1.921,5.054,5.054,0,0,0,1.124,3.413A3.85,3.85,0,0,0,72.35,74.5a4.011,4.011,0,0,0,2.522-.814,3.251,3.251,0,0,0,.8-.921,3.34,3.34,0,0,0,.411-1.188H74.977A2.46,2.46,0,0,1,72.354,73.489Z",
    transform: "translate(-52.379 -52.455)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1860",
    "data-name": "Trazado 1860",
    d: "M64.155,65.209a3.54,3.54,0,0,0-1.868.476,2.906,2.906,0,0,0-1.15,1.327h-.025V62.238a.559.559,0,0,0-1.119,0V73.867a.559.559,0,0,0,1.119,0V69.111a2.53,2.53,0,0,1-.009-.3,2.669,2.669,0,0,1,2.74-2.6,2.208,2.208,0,0,1,.424.008A2.306,2.306,0,0,1,66.3,68.764v5.1h0a.559.559,0,1,0,1.119,0v-5.28a3.459,3.459,0,0,0-.882-2.455A3.2,3.2,0,0,0,64.155,65.209Z",
    transform: "translate(-52.459 -52.489)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1861",
    "data-name": "Trazado 1861",
    d: "M68.152,52.578A15.62,15.62,0,1,0,83.771,68.2,15.637,15.637,0,0,0,68.152,52.578Zm0,30.23A14.61,14.61,0,1,1,82.761,68.2,14.627,14.627,0,0,1,68.152,82.808Z",
    transform: "translate(-52.532 -52.578)",
    fill: "#a7a7a7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHc);
export default __webpack_public_path__ + "static/media/hc.3b5e2026ddfd7a13b793a9a15bfc1864.svg";
export { ForwardRef as ReactComponent };